import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_menu_list_hdr_RowClass} from '../../../dbschema';

export class MenuListContainerModel extends BaseContainerModel {

  bl_cms_menu_list_hdr: bl_cms_menu_list_hdr_RowClass = new bl_cms_menu_list_hdr_RowClass();
}
